function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import { withHotKeys } from 'react-hotkeys';
import SideNavigation from './SideNavigation';
import BaseCarousel from './BaseCarousel';
import { DIRECTION_LEFT, DIRECTION_RIGHT, FULL_CAROUSEL_PROP_TYPES } from '../constants';
import { getPreviousIndex, getNextIndex } from './utils';
import { MOVE_TO_NEXT, MOVE_TO_PREV } from '../../hotKeys/constants';
import { ACTION_KEY_MAP } from '../hotKeys';

var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return React.createElement("div", {
    className: "eds-carousel__title"
  }, React.createElement("p", {
    className: "eds-text-hs eds-l-mar-bot-2"
  }, title), React.createElement("p", {
    className: "eds-text-bm eds-text-color--ui-500"
  }, subtitle));
};

var FullCarousel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FullCarousel, _PureComponent);

  function FullCarousel(props) {
    var _defineProperty2;

    var _this;

    _classCallCheck(this, FullCarousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullCarousel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, MOVE_TO_NEXT, _this._handleNext.bind(_assertThisInitialized(_this))), _defineProperty(_defineProperty2, MOVE_TO_PREV, _this._handlePrevious.bind(_assertThisInitialized(_this))), _defineProperty2));

    _defineProperty(_assertThisInitialized(_this), "_handleMouseEnter", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          itemsPerSlide = _this$props.itemsPerSlide;

      _this.setState({
        showNavigation: children.length > itemsPerSlide,
        autoTransition: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMouseExit", function () {
      var _this$props2 = _this.props,
          initialAutoTransition = _this$props2.initialAutoTransition,
          initialShowSideNavigation = _this$props2.initialShowSideNavigation,
          children = _this$props2.children;

      _this.setState({
        showNavigation: children.length > 1 ? initialShowSideNavigation : false,
        autoTransition: initialAutoTransition
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTransition", function (displayIndex) {
      var onTransition = _this.props.onTransition;

      _this.setState({
        displayIndex: displayIndex
      });

      if (onTransition) {
        onTransition(displayIndex);
      }
    });

    var _initialShowSideNavigation = props.initialShowSideNavigation,
        _initialAutoTransition = props.initialAutoTransition,
        initialDisplayIndex = props.initialDisplayIndex,
        _children = props.children;
    _this.state = {
      displayIndex: initialDisplayIndex,
      showNavigation: _children.length > 1 ? _initialShowSideNavigation : false,
      autoTransition: _initialAutoTransition
    };
    return _this;
  }

  _createClass(FullCarousel, [{
    key: "_handlePrevious",
    value: function _handlePrevious() {
      var _this2 = this;

      var _this$props3 = this.props,
          length = _this$props3.children.length,
          onSwipeLeft = _this$props3.onSwipeLeft,
          isNotContinuous = _this$props3.isNotContinuous;
      this.setState(getPreviousIndex.bind(null, length, !isNotContinuous), function () {
        if (onSwipeLeft) {
          onSwipeLeft({
            currentIndex: _this2.state.displayIndex
          });
        }
      });
    }
  }, {
    key: "_handleNext",
    value: function _handleNext() {
      var _this3 = this;

      var _this$props4 = this.props,
          length = _this$props4.children.length,
          onSwipeRight = _this$props4.onSwipeRight,
          isNotContinuous = _this$props4.isNotContinuous;
      this.setState(getNextIndex.bind(null, length, !isNotContinuous), function () {
        if (onSwipeRight) {
          onSwipeRight({
            currentIndex: _this3.state.displayIndex
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          bottomNavigationType = _this$props5.bottomNavigationType,
          children = _this$props5.children,
          fullWidth = _this$props5.fullWidth,
          itemsPerSlide = _this$props5.itemsPerSlide,
          customNavigation = _this$props5.customNavigation,
          showBottomNavigation = _this$props5.showBottomNavigation,
          fixAspectRatio = _this$props5.fixAspectRatio,
          isNotContinuous = _this$props5.isNotContinuous,
          transitionDuration = _this$props5.transitionDuration,
          usesNewStyle = _this$props5.usesNewStyle,
          title = _this$props5.title,
          subtitle = _this$props5.subtitle;
      var _this$state = this.state,
          displayIndex = _this$state.displayIndex,
          autoTransition = _this$state.autoTransition,
          showNavigation = _this$state.showNavigation;
      var titleHeader = null;

      if (title) {
        titleHeader = React.createElement(Title, {
          title: title,
          subtitle: subtitle
        });
      }

      var isLeftNavigationDisabled = isNotContinuous && displayIndex === 0;
      var leftNavigationNode = React.createElement(SideNavigation, {
        bottomNavigationType: bottomNavigationType,
        fullWidth: fullWidth,
        type: DIRECTION_LEFT,
        shouldShow: showNavigation,
        onClick: this._handlePrevious.bind(this),
        isDisabled: isLeftNavigationDisabled,
        usesNewStyle: usesNewStyle
      });
      var isRightNavigationDisabled = isNotContinuous && displayIndex === children.length - 1;
      var rightNavigationNode = React.createElement(SideNavigation, {
        bottomNavigationType: bottomNavigationType,
        fullWidth: fullWidth,
        type: DIRECTION_RIGHT,
        shouldShow: showNavigation,
        onClick: this._handleNext.bind(this),
        isDisabled: isRightNavigationDisabled,
        usesNewStyle: usesNewStyle
      });
      return React.createElement("div", {
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseExit
      }, React.createElement(BaseCarousel, {
        bottomNavigationType: bottomNavigationType,
        fullWidth: fullWidth,
        itemsPerSlide: itemsPerSlide,
        inheritedDisplayIndex: displayIndex,
        autoTransition: autoTransition,
        onTransition: this._handleTransition,
        customNavigation: customNavigation,
        showNavigation: showBottomNavigation,
        leftNavigationNode: leftNavigationNode,
        rightNavigationNode: rightNavigationNode,
        fixAspectRatio: fixAspectRatio,
        transitionDuration: transitionDuration,
        usesNewStyle: usesNewStyle,
        title: titleHeader,
        onPrevious: this._handlePrevious.bind(this),
        onNext: this._handleNext.bind(this)
      }, children));
    }
  }]);

  return FullCarousel;
}(PureComponent);

_defineProperty(FullCarousel, "propTypes", FULL_CAROUSEL_PROP_TYPES);

export default withHotKeys(ACTION_KEY_MAP)(FullCarousel);